import { api } from './api';
import { useAuthStore } from '@/store/auth.store';

const DEDUP_WINDOW_MS = 5000;
const recentPersists = new Map<string, number>();

function dedupeKey(title: string, body?: string): string {
  return `${title}::${body ?? ''}`;
}

/**
 * Persist a toast notification as a user_notification via POST /user-notifications/self.
 * Fire-and-forget: failures are silently ignored to avoid recursive error toasts.
 */
export function persistToast(data: {
  title: string;
  body?: string;
  priority?: 'low' | 'normal' | 'high' | 'urgent';
  action_url?: string;
  resource_type?: string;
  resource_id?: string;
}): void {
  // Skip if user is not authenticated
  if (!useAuthStore.getState().token) return;

  // Deduplicate: skip if same title+body was persisted in last 5 seconds
  const key = dedupeKey(data.title, data.body);
  const now = Date.now();
  const lastPersisted = recentPersists.get(key);
  if (lastPersisted && now - lastPersisted < DEDUP_WINDOW_MS) return;
  recentPersists.set(key, now);

  // Clean up old entries periodically
  if (recentPersists.size > 100) {
    for (const [k, ts] of recentPersists) {
      if (now - ts > DEDUP_WINDOW_MS) recentPersists.delete(k);
    }
  }

  // Fire-and-forget POST
  api.post('/user-notifications/self', data).catch(() => {
    // Intentionally silent — don't trigger a secondary toast on failure
  });
}
